import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { ContainerType } from './enums/containerType.enum';
import { ContainerProps } from './props';
import './styles.scss';

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, type = ContainerType.PRIMARY, children, onClick }, ref) => (
    <div className={classnames('fr-container', `fr-container--${type}`, className)} onClick={onClick} ref={ref}>
      {children}
    </div>
  ),
);

Container.displayName = 'Container';
